export const data = [
  {
    id: 1,
    projectName: "Amazon Clone",
    imgSrc:
      "https://user-images.githubusercontent.com/61752151/131874539-646d6563-3b3a-4b4e-a139-42d6ce3b67c0.png",
    demoSrc: "https://github.com/Deepak-1373/amazon-clone-app",
    codeSrc: "https://github.com/Deepak-1373/amazon-clone-app",
  },
  {
    id: 2,
    projectName: "Netflix Clone",
    imgSrc:
      "https://user-images.githubusercontent.com/61752151/156299054-d8906e2c-90c5-4c58-b720-a57c4108b701.png",
    demoSrc: "https://deepak1373-netflix-ui-clone.netlify.app/",
    codeSrc: "https://github.com/Deepak-1373/netflix-clone",
  },
  {
    id: 3,
    projectName: "Keeper App",
    imgSrc:
      "https://user-images.githubusercontent.com/61752151/167562950-f5e50b98-56d5-4593-bc5b-cd96132d6920.png",
    demoSrc: "https://keeper-app-deepak1373.netlify.app/",
    codeSrc: "https://github.com/Deepak-1373/keeper-app",
  },
  {
    id: 4,
    projectName: "COVID-19 Tracker",
    imgSrc:
      "https://user-images.githubusercontent.com/61752151/167560417-0827899c-712a-4e92-ae50-b2706ca5a0d5.jpg",
    demoSrc: "https://covid-19-tracker-3baed.web.app/",
    codeSrc: "https://github.com/Deepak-1373/COVID-19-Tracker",
  },
  {
    id: 5,
    projectName: "Expense Tracker",
    imgSrc:
      "https://user-images.githubusercontent.com/61752151/167560875-93755d7b-b364-42cd-9c3c-83791a3f776b.jpg",
    demoSrc:
      "https://6214916cfff7305328300614--expense-tracker-2-0.netlify.app/",
    codeSrc: "https://github.com/Deepak-1373/Expense-Tracker",
  },
  {
    id: 6,
    projectName: "Pokedex",
    imgSrc:
      "https://user-images.githubusercontent.com/61752151/167561489-c3cf7d92-7e71-4b76-9416-ca9c0c09813e.png",
    demoSrc:
      "https://62075e9d8725bc000877bc24--deepak-1373-pokedex.netlify.app/",
    codeSrc: "https://github.com/Deepak-1373/Pokedex",
  },
];
